webpackJsonp([176903080081458],{

/***/ 211:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ThoughtBox = function ThoughtBox(props) {
	  return _react2.default.createElement(
	    'section',
	    { className: 'thought box' },
	    _react2.default.createElement(
	      'a',
	      { href: props.link, target: '_blank' },
	      _react2.default.createElement(
	        'h4',
	        null,
	        props.title
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'meta' },
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement('i', { className: 'fa fa-calendar-o' }),
	          ' ',
	          props.month,
	          ' ',
	          props.year
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement('i', { className: 'fa fa-clock-o' }),
	          ' ',
	          props.minutes,
	          ' min'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'text-container' },
	      _react2.default.createElement(
	        'p',
	        null,
	        props.blurb
	      )
	    ),
	    _react2.default.createElement(
	      'a',
	      { className: 'cta', href: props.link, target: '_blank' },
	      _react2.default.createElement(
	        'span',
	        { className: 'hide-mobile-small' },
	        'See More on '
	      ),
	      props.publicationName,
	      ' ',
	      _react2.default.createElement('i', { className: 'fa fa-arrow-right' })
	    )
	  );
	};
	
	exports.default = ThoughtBox;
	module.exports = exports['default'];

/***/ }),

/***/ 217:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _thoughtBox = __webpack_require__(211);
	
	var _thoughtBox2 = _interopRequireDefault(_thoughtBox);
	
	var _cta = __webpack_require__(41);
	
	var _cta2 = _interopRequireDefault(_cta);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ThoughtsPage = function ThoughtsPage(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    'section',
	    null,
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Thoughts'
	    ),
	    _react2.default.createElement(
	      'section',
	      { id: 'thoughts', className: 'container' },
	      data.allThoughtsYaml.edges.map(function (_ref2, index) {
	        var node = _ref2.node;
	        return _react2.default.createElement(_thoughtBox2.default, {
	          key: node.title,
	          title: node.title,
	          blurb: node.blurb,
	          link: node.link,
	          year: node.year,
	          month: node.month,
	          minutes: node.minutes,
	          publicationName: node.publicationName
	        });
	      })
	    ),
	    _react2.default.createElement(_cta2.default, { primary: { to: '/inspiration', text: 'View Inspiration' }, scrollToTop: true })
	  );
	};
	
	exports.default = ThoughtsPage;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-thoughts-js-58e413730f64f6ef7a52.js